import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ArticuloService } from '../../services/articulo.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-articulo-preview',
  templateUrl: './articulo-preview.component.html',
  styleUrls: ['./articulo-preview.component.css']
})
export class ArticuloPreviewComponent implements OnInit {
  currentArticle = 0
  titleTxt: string = 'hablemos de dar vida\na los locales'

  datepipe: DatePipe = new DatePipe('es-ES')

  article: any = {}

  id_next: number = 0
  id_prev: number = 0

  imgBigUrl: string = ''
  fecha: string | null = ''

  videoURI: SafeResourceUrl | undefined;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private sanitizer: DomSanitizer,
    private articuloService: ArticuloService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false; // Can reload the page
    this.route.params.subscribe(params => {
      this.currentArticle = params['id']
    });
  }
  public safeURL(value: any): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }

  ngOnInit(): void {
    this.articuloService.getArticuloPreview(this.currentArticle).subscribe(
      (resp) => {
        this.article = resp
        this.imgBigUrl = 'https://' + this.article.imgBigUrl
        this.fecha = this.article.date
        this.fecha = this.datepipe.transform(this.fecha, 'dd MMMM yyyy')

        if (resp.next) {
          if (resp.next.id != null) { this.id_next = resp.next.id }
        }
        if (resp.prev) {
          if (resp.prev.id != null) { this.id_prev = resp.prev.id }
        }

        this.videoURI = this.safeURL(this.article.videoUrl)
        this.titleService.setTitle('retailCo Prensa: ' + this.article.title);
      },
      (err) => { }
    )
  }

}
